import { IconButton } from '@mui/material';
import { ArrowIcon } from 'assets/icons/ArrowIcon';
import { useState } from 'react';
import { getSpacing } from 'stylesheet';

import {
  CollapsableFormZoneContainer,
  CollapsableFormZoneContent,
  CollapsableFormZoneTitle,
} from './CollapsableFormZone.style';

interface CollapsableFormZoneProps {
  title: string;
  children: JSX.Element;
}

export const CollapsableFormZone = ({ title, children }: CollapsableFormZoneProps) => {
  const [titleAdditionalStyles, setTitleAdditionalStyles] = useState<Record<string, string>>({});
  const [isDetailsDisplayed, setIsDetailsDisplayed] = useState(true);
  const toggleDetailsDisplay = () => {
    setIsDetailsDisplayed(!isDetailsDisplayed);
    setTitleAdditionalStyles({
      'border-bottom-left-radius': isDetailsDisplayed ? getSpacing(2) : getSpacing(0),
      'border-bottom-right-radius': isDetailsDisplayed ? getSpacing(2) : getSpacing(0),
    });
  };
  return (
    <CollapsableFormZoneContainer>
      <CollapsableFormZoneTitle style={titleAdditionalStyles}>
        {title}
        <IconButton onClick={toggleDetailsDisplay}>
          <ArrowIcon arrowDirection={isDetailsDisplayed ? 'down' : 'top'} />
        </IconButton>
      </CollapsableFormZoneTitle>
      {isDetailsDisplayed && <CollapsableFormZoneContent>{children}</CollapsableFormZoneContent>}
    </CollapsableFormZoneContainer>
  );
};
